import React, { useState, useEffect } from "react";
import {
  Heading, Button, UnorderedList, ListItem, Box, Text, Link, Center, Container,
  useDisclosure,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';
import Dnd, { Blank } from "./components/Dnd";
import Separator from "./components/Separator";

// https://docs.dndkit.com/introduction/getting-started
// Modified the Multiple Containers Grid example on Storybook
// https://5fc05e08a4a65d0021ae0bf2-xkdjvdfnuz.chromatic.com/?path=/docs/presets-sortable-multiple-containers--grid
// code here: https://github.com/clauderic/dnd-kit/blob/b7355d19d9e15bb1972627bb622c2487ddec82ad/stories/2%20-%20Presets/Sortable/MultipleContainers.tsx

// TODO: make custom "coordinates getter" to improve UX of keyboard navigation -- https://docs.dndkit.com/api-documentation/sensors/keyboard

export default function App() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [weeklyScripture, setWeeklyScripture] = useState('');
  const [chapter, setChapter] = useState('');
  const [question, setQuestion] = useState('');

  // Get the current date
  const currentDate = new Date();

  // Format the date as 'YYYY-MM-DD'
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const previousSundayDate = convertDate(formattedDate);

  const url = `https://bible-quizlet.s3.ap-northeast-2.amazonaws.com/${previousSundayDate}.txt`

  useEffect(() => {
    fetch(url)
      .then(response => response.text())
      // .then(data => {
      //   console.log(data)
      // })
      .then(data => {
        const parts = data.split(/\n\n/g);
        if (parts.length != 3) {
          console.error('The file does not have exactly three parts separated by an empty line.');
          return;
        }
        setWeeklyScripture(parts[0]);
        setChapter(parts[1]);
        setQuestion(parts[2]);
        onOpen();
      })
  }, []);

  const lines = question.split(/\r?\n/);

  const components = lines.map((line, index) => {
    const regex = /{{([^}]+)}}/g;
    const matches = question.match(regex);
    if (!matches) {
      return line;
    }
    const lineComponents = line.split(regex).map((item, index) => {
      if (matches.includes(`{{${item}}}`)) {
        return <Blank key={index} solution={item} />;
      }
      return item;
    });

    return <Dnd taskId={`${index}+1`} children={lineComponents}></Dnd>
  });

  const handleButtonClick = () => {
    Kakao.Share.sendCustom({
      templateId: 107918,
      templateArgs: {
        DATE: `${formatDate(previousSundayDate)}`
      },
    });
  };

  return (
    <Container maxW={{ base: "100%", md: "640px" }} px={{ base: "4" }}>
      <Box overflowX="hidden">
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>이번 주 암송 구절</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>{weeklyScripture}</Text>
            </ModalBody>

            <ModalFooter>
              <Button onClick={onClose}>
                네, 확인했어요!
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Heading as="h1" textAlign="center" mt="10">
          성경 통독 문답
        </Heading>

        <Heading as="h4" size="md" mt="3" textAlign="center">({formatDate(previousSundayDate)})</Heading>

        <Separator />

        <Heading as="h4" size="md" mb="3" textAlign="center"># 이번 주 통독 본문</Heading>

        <Center><BulletList alignItems="center" items={chapter} /></Center>

        <Separator />

        {components}

        <Separator />

        <Box align="center">
          <Button onClick={handleButtonClick}>카카오톡 공유</Button>

          <Text mt="6" mb="6">Copyright 2023 <Link href="https://gongheung.com/bible-reading" isExternal textDecoration="underline">양평공흥교회</Link></Text>
        </Box>
      </Box>
    </Container>
  );
}

function convertDate(dateString) {
  const date = new Date(dateString);
  const dayOfWeek = date.getDay();

  // If the date is already a Sunday, subtract 7 days
  if (dayOfWeek === 0) {
    date.setDate(date.getDate() - 7);
  } else {
    date.setDate(date.getDate() - dayOfWeek);
  }

  return date.toISOString().slice(0, 10);
}

function formatDate(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}.${month}.${day}`;
}

function BulletList({ items }) {
  return (
    <UnorderedList>
      {items.split('\n').map((item, index) => (
        <ListItem key={index}>{item}</ListItem>
      ))}
    </UnorderedList>
  );
}
